import React from 'react';
import { Divider, Grid } from '@mantine/core';
import { IconBuilding, IconClock, IconGauge, IconListDetails, IconSettings, IconSun, IconTool } from '@tabler/icons-react';
import type { IFactorServicio, IFactorVelocidadServicio } from '../../../modelos/CotizadorServicios/entidades/IParametrosServicios';
import { TarjetaTablaEditable } from '../../../globales/componentes/tabla/tarjetaTablaEditable';
import type { ITablaEditable } from '../../../globales/componentes/tabla/useEdicionFilas';
import { columnasFactor, columnasVelocidad } from './constantesTablasParametros';

const COLUMNAS_VELOCIDAD = columnasVelocidad();
const COLUMNAS_USO = columnasFactor('Tipo de uso');
const COLUMNAS_TIPO_EQUIPO = columnasFactor('Tipo de equipo');
const COLUMNAS_ENTORNO = columnasFactor('Entorno');
const COLUMNAS_HORARIO = columnasFactor('Horario');
const COLUMNAS_CUARTO = columnasFactor('Cuarto de máquinas');
const COLUMNAS_APF = columnasFactor('APF');

interface CatalogosServiciosVistaProps {
    velocidadesAscensor: ITablaEditable<IFactorVelocidadServicio>;
    tiposUso: ITablaEditable<IFactorServicio>;
    tiposEquipoEscalera: ITablaEditable<IFactorServicio>;
    velocidadesEscalera: ITablaEditable<IFactorVelocidadServicio>;
    entornosOperativos: ITablaEditable<IFactorServicio>;
    horariosTrabajo: ITablaEditable<IFactorServicio>;
    cuartoMaquinas: ITablaEditable<IFactorServicio>;
    apf: ITablaEditable<IFactorServicio>;
}

const Seccion: React.FC<{ titulo: string }> = ({ titulo }) => (
    <Grid.Col span={12}>
        <Divider label={titulo} labelPosition="center" />
    </Grid.Col>
);

// Dos tarjetas por fila en Ascensores y tres en las demás secciones: cada fila queda completa.
const MITAD = { base: 12, md: 6 };
const TERCIO = { base: 12, md: 6, lg: 4 };

/** Pestaña "Catálogos y Factores": opciones de los selectores de la cotización y su factor. */
export const CatalogosServiciosVista: React.FC<CatalogosServiciosVistaProps> = (props) => (
    <Grid gutter="md">
        <Seccion titulo="Ascensores" />
        <Grid.Col span={MITAD}>
            <TarjetaTablaEditable titulo="Velocidades" icono={<IconGauge size={18} />} tabla={props.velocidadesAscensor} columnas={COLUMNAS_VELOCIDAD} />
        </Grid.Col>
        <Grid.Col span={MITAD}>
            <TarjetaTablaEditable titulo="Tipo de Uso" icono={<IconBuilding size={18} />} tabla={props.tiposUso} columnas={COLUMNAS_USO} />
        </Grid.Col>

        <Seccion titulo="Escaleras, Rampas y Andenes" />
        <Grid.Col span={TERCIO}>
            <TarjetaTablaEditable titulo="Tipo de Equipo" icono={<IconSettings size={18} />} tabla={props.tiposEquipoEscalera} columnas={COLUMNAS_TIPO_EQUIPO} />
        </Grid.Col>
        <Grid.Col span={TERCIO}>
            <TarjetaTablaEditable titulo="Velocidades" icono={<IconGauge size={18} />} tabla={props.velocidadesEscalera} columnas={COLUMNAS_VELOCIDAD} />
        </Grid.Col>
        <Grid.Col span={TERCIO}>
            <TarjetaTablaEditable titulo="Entorno Operativo" icono={<IconSun size={18} />} tabla={props.entornosOperativos} columnas={COLUMNAS_ENTORNO} />
        </Grid.Col>

        <Seccion titulo="Comunes" />
        <Grid.Col span={TERCIO}>
            <TarjetaTablaEditable titulo="Horario de Trabajo" icono={<IconClock size={18} />} tabla={props.horariosTrabajo} columnas={COLUMNAS_HORARIO} />
        </Grid.Col>
        <Grid.Col span={TERCIO}>
            <TarjetaTablaEditable titulo="Cuarto de Máquinas" icono={<IconTool size={18} />} tabla={props.cuartoMaquinas} columnas={COLUMNAS_CUARTO} />
        </Grid.Col>
        <Grid.Col span={TERCIO}>
            <TarjetaTablaEditable titulo="APF" icono={<IconListDetails size={18} />} tabla={props.apf} columnas={COLUMNAS_APF} />
        </Grid.Col>
    </Grid>
);
